import { useEffect } from "react";
import { useAppDispatch } from "state";
import { State } from "./types";
import { useSelector } from "react-redux";
import { LocalStoragePersistanceService } from "persist/LocalStorage";
import { setUserData } from "./users";
import { setBookmarkFolder, setRecentFolder } from "./folders";

const localStore = new LocalStoragePersistanceService();

export const useFetchPublicData = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    const user = localStore.getItem("user");
    const jwt = localStore.getItem("jwt");
    if (user && jwt) {
      dispatch(setUserData({ user, jwt }));
    }

    const recent = localStore.getItem("recent");
    const bookmark = localStore.getItem("bookmark");

    if (recent) {
      dispatch(setRecentFolder(recent));
    }

    if (bookmark) {
      dispatch(setBookmarkFolder(bookmark));
    }
  }, [dispatch]);
}; // end of use Fetch Public Data

// User
export const useUser = () => {
  return useSelector((state: State) => state.user);
};

export const useJWT = () => {
  return useSelector((state: State) => state.user.jwt);
};

// Folders

export const useRecentFolders = () => {
  return useSelector((state: State) => state.folderState.recentFolder);
};

export const useRecentFolder = (folderId) => {
  return useSelector((state: State) =>
    state.folderState.recentFolder.folders.find((p) => p.id === folderId)
  );
};

export const useRecentFiles = (fileId) => {
  return useSelector((state: State) =>
    state.folderState.recentFolder.files.find((p) => p.id === fileId)
  );
};

export const useBookmarkFolders = () => {
  return useSelector((state: State) => state.folderState.bookmarkFolder);
};

export const useBookmarkFolder = (folderId) => {
  return useSelector((state: State) =>
    state.folderState.bookmarkFolder.folders.find((p) => p.id === folderId)
  );
};

export const useBookmarkFiles = (fileId) => {
  return useSelector((state: State) =>
    state.folderState.bookmarkFolder.files.find((p) => p.id === fileId)
  );
};
